import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import {
  FiHome,
  FiBox,
  FiPackage,
  FiArrowLeft,
  FiLogOut,
  FiUsers,
} from "react-icons/fi";
import { useUserId } from "../UserIdContext";
import {
  buildBinderSearch,
  normalizeDepositoRouteValue,
  readDepositoFromSearch,
} from "../lib/depositoRoute";
import "./menu.css";
import { MENU_LOGO_SRC, MENU_LOGO_ALT } from "./menuLogo";
import SidebarCollapseButton from "./SidebarCollapseButton";

export default function MenuOperaciones({ defaultOpen = true, onToggle }) {
  const { setDeposito, deposito, isAdmin, isLogistica } = useUserId();
  const [open, setOpen] = useState(defaultOpen);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  useEffect(() => {
    onToggle && onToggle(open);
  }, [open, onToggle]);

  const toggleMenu = () => setOpen((v) => !v);

  const goToMes = (dep) => {
    setDeposito(dep);
    const query = isLogistica
      ? `?dep=${encodeURIComponent(dep)}`
      : `?cal=1&dep=${encodeURIComponent(dep)}`;
    navigate(`/operaciones${query}`);
  };

  const handleLogout = () => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("usuario");
      localStorage.removeItem("binderDeposito");
    } catch {
      /* ignore storage errors */
    }
    setDeposito(null);
    navigate("/");
  };

  const handleVolver = () => {
    setDeposito(null);
    try {
      localStorage.removeItem("binderDeposito");
    } catch {
      /* ignore storage errors */
    }
    navigate("/iniciogeneral");
  };

  const search = new URLSearchParams(location.search || "");
  const calParam = search.get("cal");
  const routeDeposito = readDepositoFromSearch(location.search);
  const depositoActual =
    routeDeposito || normalizeDepositoRouteValue(deposito) || "binder1";
  const inicioHref = `/inicioOperaciones${buildBinderSearch(depositoActual)}`;
  const hasCal = calParam !== null;

  const isBinderView =
    location.pathname === "/operaciones" && hasCal;

  const binderActive = (dep) =>
    isBinderView &&
    (routeDeposito === dep ||
      (!routeDeposito &&
        normalizeDepositoRouteValue(deposito) === dep));

  const showUsuarios = isAdmin;
  const logoMaskStyle = {
    "--ops-logo-mask": `url(${MENU_LOGO_SRC})`,
  };

  return (
    <aside className={`ops-menu ops-menu--operaciones ${open ? "open" : "collapsed"}`}>
      <SidebarCollapseButton open={open} onToggle={toggleMenu} controls="operations-sidebar-content" />
      <div className="ops-menu-content" id="operations-sidebar-content">
      <div className="ops-menu-header">
        <div
          className="ops-logo"
          style={logoMaskStyle}
          onClick={() => navigate(inicioHref)}
        >
          <img src={MENU_LOGO_SRC} alt={MENU_LOGO_ALT} />
    
        </div>
      </div>

      <nav className="ops-nav">
        <NavLink
          to={inicioHref}
          title="Inicio"
          className={() =>
            "ops-nav-item" + (location.pathname === "/inicioOperaciones" ? " active" : "")
          }
        >
          <FiHome />
          <span>Inicio</span>
        </NavLink>
        <div
          className={
            "ops-nav-item ops-nav-item--short clickable" +
            (binderActive("binder1") ? " active" : "")
          }
          onClick={() => goToMes("binder1")}
          title="Binder 1"
        >
          <FiBox />
          <span>Binder 1</span>
          <span className="ops-nav-short">B1</span>
        </div>

        <div
          className={
            "ops-nav-item ops-nav-item--short clickable" +
            (binderActive("binder2") ? " active" : "")
          }
          onClick={() => goToMes("binder2")}
          title="Binder 2"
        >
          <FiPackage />
          <span>Binder 2</span>
          <span className="ops-nav-short">B2</span>
        </div>
        {showUsuarios && (
          <NavLink
            to="/UsuariosOperaciones"
            title="Usuarios"
            className={({ isActive }) =>
              "ops-nav-item" + (isActive ? " active" : "")
            }
          >
            <FiUsers />
            <span>Usuarios</span>
          </NavLink>
        )}
      </nav>

      <div
        className="ops-nav"
        style={{ marginTop: "auto", padding: "0 12px 16px" }}
      >
        <button
          className="ops-nav-item clickable"
          onClick={handleVolver}
          style={{ width: "100%" }}
        >
          <FiArrowLeft />
          <span>Volver</span>
        </button>
        <button
          className="ops-nav-item clickable"
          onClick={handleLogout}
          style={{ width: "100%" }}
        >
          <FiLogOut />
          <span>Cerrar sesion</span>
        </button>
      </div>
      </div>
    </aside>
  );
}
